import theme from '@globals/themes/defaultTheme'
import { onActive, onFocus, onHover } from '@globals/themes/themeConstants'
import { useCurrentMember } from '@globals/useCurrentMember'
import { useRecoveryBannerHeight } from '@globals/useRecoveryBannerStore'
import { useTrialBannerHeight } from '@globals/useTrialBannerStore'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { SxProps } from '@mui/material/styles'
import UserAvatar from '@shared/avatar/UserAvatar'
import { useT } from '@transifex/react'
import { SetStateAction, useState } from 'react'
import TenantMemberAvatarPopover from './TenantMemberAvatarPopover'

const getContainerStyles = (bannerHeight: number): SxProps => ({
  position: 'fixed',
  top: bannerHeight + 8, // NOTE: Matches 'top' in InAppNotifications' getButtonStyle
  right: { xs: 16, lg: 76 },
  zIndex: theme.zIndex.appBar + 1,
})

const iconButtonStyles: SxProps = {
  padding: 0,
  boxShadow: 'none',
  backgroundColor: 'transparent',
  [`${onHover}, ${onFocus}, ${onActive}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}

const TenantMemberAvatar: React.FC = () => {
  const t = useT()
  const { member } = useCurrentMember()
  const { trialBannerHeight } = useTrialBannerHeight()
  const { recoveryBannerHeight } = useRecoveryBannerHeight()
  const bannerHeight = trialBannerHeight + recoveryBannerHeight
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  if (!member) return null

  const { id, avatarUrls, firstName, lastName } = member

  const handleOpen = (e: { currentTarget: SetStateAction<HTMLButtonElement | null> }) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box sx={getContainerStyles(bannerHeight)}>
      <Button
        sx={iconButtonStyles}
        onClick={handleOpen}
        id="btnTenantMemberAvatar"
        aria-label={t('Tenant member avatar button')}>
        <UserAvatar
          size={36}
          tenantMemberId={id}
          media={avatarUrls}
          firstName={firstName}
          lastName={lastName}
          eager
        />
      </Button>
      <TenantMemberAvatarPopover onClose={handleClose} anchorEl={anchorEl} member={member} />
    </Box>
  )
}

export default TenantMemberAvatar
